<template>
  <v-row align="center" justify="center" class="mt-6">
    <v-card max-width="95%" width="500" flat color="background">
      <v-row align="center" justify="center">
        <v-col cols="5">
            <v-row align="center" justify="center">
              <h1 class="textColor">+250,000</h1>
            </v-row>
            <v-row align="center" justify="center">
              <p>litros vendidos</p>
            </v-row>
          </v-col>
          <v-divider vertical></v-divider>
          <v-col cols="5">
            <v-row align="center" justify="center">
              <h1 class="textColor">4.89</h1>
            </v-row>
            <v-row align="center" justify="center">
              <p>calificación</p>
            </v-row>
          </v-col>
      </v-row>
    </v-card>
  </v-row>
</template>

<script>

export default {
  data() {
    return {
    };
  },
};
</script>

<style scoped>
.textColor {
  color: #4FD8D8;
}
.v-btn--outlined .v-btn__content .v-icon, .v-btn--round .v-btn__content .v-icon {
    color: #4FD8D8;
}
</style>